import { gql } from "@apollo/client"
import { ContingencyCtaApplylistFragment } from "@pallet/features/ApplylistType/components/ContingencyTierCta/fragments"

export const ContingencyPlanBannerApplylistFragment = gql`
    fragment ContingencyPlanBanner_applylist on ApplylistType {
        id
        ...ContingencyCta_applylist
    }
    ${ContingencyCtaApplylistFragment}
`
